import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import { SOCKET_ACTIONS, API_URL } from '../../../constants';
import * as contactActions from '../../../state/contacts/actions';
import { useDispatch } from 'react-redux';

const {
  CONTACTS
} = SOCKET_ACTIONS;

const ENDPOINT = API_URL; // Replace with your server URL

function SupervisoresSocket({ userId}) { // Example props that might change
    const [socket, setSocket] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        // Disconnect existing socket if it exists
        if (socket) {
            socket.disconnect();
        }

        // Connect with new parameters
        const newSocket = io(ENDPOINT, {
            query: {
                user: userId
            }
        });
        newSocket.on(CONTACTS.INCOMING_MESSAGE, (data) => {
            const newData = { ...data, supervisor : true };
            dispatch(contactActions.incomingMessage(newData));
        });
        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        };
    }, [userId]); // Reconnect when userId or roomId changes

   return(
    <></>
   )
}

export default SupervisoresSocket;